import * as z from "zod";

export const AddProyectoSchema = z.object({
	nombre: z.string().min(1, "El nombre es obligatorio"),
	descripcion: z.string(),
	referencia: z.string().min(1, "La referencia es obligatoria"),
	externo: z.enum(["propio", "externo"], {
		error: "El tipo es obligatorio",
	}),
	alcance: z.enum(["cuna_puerta", "puerta_puerta"], {
		error: "El alcance es obligatorio",
	}),
});
export type AddProyectoSchema = z.infer<typeof AddProyectoSchema>;
